import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
import {defineState} from 'redux-localstore';

const defaultState = {
  proposals: [],
  error: false,
  loading: false,
  lastSync: false
};

const initialState = defineState(defaultState)('proposals');

const fetchStart = (state) => {
  return updateObject(state, { error: false, loading: true, lastSync: false });
};

const fetchSuccess = (state, action) => {
  const result = action.proposals.length > 0 ? action.proposals : [];  
  return updateObject(state, {
    proposals: result,
    error: false,
    loading: false,
    lastSync: new Date()
  });
};

const fetchFail = (state) => {
  return updateObject(state, { error: true, loading: false, lastSync: false, proposals: [] });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PROPOSALS_START:
      return fetchStart(state);
    case actionTypes.FETCH_PROPOSALS_SUCCESS:
      return fetchSuccess(state, action);
    case actionTypes.FETCH_PROPOSALS_FAILED:
      return fetchFail(state);
    default:
      return {
        ...state,
        error: true,
        loading: false
      };
  }
};

export default reducer;
